import config from 'config';
import { RELATION } from 'constants/relation';
import http from 'utils/http';
import { stringify } from 'utils/queryParam';
import { buildUrl } from 'utils/string';

interface OffboardFeedbackFilter {
  userId: string;
}

export async function fetchOffboardFeedbacks(filter: OffboardFeedbackFilter) {
  const params = { ...filter, offboard: true, relation: RELATION.APPRAISER };
  const url = stringify(buildUrl(config.pulseApiUrl, config.endpoints.pulse.dashboard), params);
  const { data } = await http.get(url);

  return data;
}
